import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { PanelBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Spacer from "@ui/spacer/Spacer";
import { Typo } from "@ui/text/Typo";

export const NoRecords = ({ line1, line2, title, onClick }: { line1: string; line2?: string; title?: string; onClick?: () => void }) => {
	useLocale();
	return (
		<PanelBox variant="no-records" style={{ justifyContent: "center" }}>
			<Typo variant="medium" bold sx={{ textAlign: "center" }}>
				{line1}
			</Typo>
			{line2 && (
				<Typo variant="medium" bold sx={{ textAlign: "center" }}>
					{line2}
				</Typo>
			)}
			{onClick && (
				<>
					<Spacer />
					<Button variant="primarySmall" onClick={onClick} title={title ? title : msg("addRecord")} />
				</>
			)}
		</PanelBox>
	);
};
